import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Typography,
  Box,
  Snackbar,
  Button,
  Alert,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";
import style from "../../../../styles/brsr/general.module.css";
import EastIcon from "@mui/icons-material/East";
import { put, api, get } from "../../../../utils/api";
import DynamicTable from "../../../Common/DynamicTable";
import {
  validateLeadershipTable,
  validateTable,
} from "../../../../utils/validateTable";
import { restructureData } from "../../../../utils/restructureData";
import { useNavigate, useParams } from "react-router-dom";
import { brsrReview, reviewBRSR } from "../../../../utils/companyId";
import ReviewBox from "../../../Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";
import BRSRFile from "../../../Common/BRSRFile";

const CustomTableRow = ({
  label,
  fields,
  formData,
  handleInputChange,
  placeholder,
  errors,
  disabled,
}) => (
  <TableRow>
    <TableCell>{label}</TableCell>
    {fields.map((field) => (
      <TableCell key={field}>
        <TextField
          name={field}
          disabled={disabled}
          value={formData[field]}
          onChange={handleInputChange}
          size="small"
          placeholder={placeholder}
          type="number"
          inputProps={{
            min: 0,
            inputMode: "numeric",
            pattern: "[0-9]*",
            style: { appearance: "textfield" },
          }}
          onWheel={(e) => e.target.blur()} // Prevents scroll from changing the value
          sx={{
            "& .MuiOutlinedInput-notchedOutline": { border: "none" },
            "& input[type=number]": { "-moz-appearance": "textfield" },
            "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
              {
                "-webkit-appearance": "none",
                margin: 0,
              },
          }}
          InputProps={{ disableUnderline: true }}
          error={!!errors[field]}
        />
      </TableCell>
    ))}
  </TableRow>
);

const FinancialYearTable = ({
  title,
  formData,
  handleInputChange,
  errors,
  disabled,
}) => {
  const categories = [
    {
      label: "Plastics (include packaging)",
      fields: ["plasticsReUsed", "plasticsRecycled", "plasticsSafelyDisposed"],
    },
    {
      label: "E-Waste",
      fields: ["eWasteReUsed", "eWasteRecycled", "eWasteSafelyDisposed"],
    },
    {
      label: "Hazardous Waste",
      fields: [
        "hazardousWasteReUsed",
        "hazardousWasteRecycled",
        "hazardousWasteSafelyDisposed",
      ],
    },
    {
      label: "Other Waste",
      fields: [
        "otherWasteReUsed",
        "otherWasteRecycled",
        "otherWasteSafelyDisposed",
      ],
    },
  ];

  return (
    <>
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "15px",
          mt: 2,
          textDecoration: "underline",
        }}
        gutterBottom
      >
        {title}
      </Typography>
      <TableContainer component={Paper}>
        <Table
          sx={{
            "& .MuiTableCell-root": {
              padding: "8px",
              borderRight: "1px solid #e0e0e0",
            },
          }}
        >
          <TableHead>
            <TableRow sx={{ bgcolor: "#1C486B", height: "40px" }}>
              <TableCell sx={{ color: "white", width: "25%" }}>
                Category
              </TableCell>
              <TableCell sx={{ color: "white", width: "25%" }}>
                Reused
              </TableCell>
              <TableCell sx={{ color: "white", width: "25%" }}>
                Recycled
              </TableCell>
              <TableCell sx={{ color: "white", width: "25%" }}>
                Safely Disposed
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {categories.map((category) => (
              <CustomTableRow
                disabled={disabled}
                key={category.label}
                label={category.label}
                fields={category.fields}
                formData={formData}
                handleInputChange={handleInputChange}
                placeholder="Metric Tons"
                errors={errors}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

// Main component
const LeadershipIndicator = ({
  onSave,
  hide,
  removeUpload = false,
  downloadMode = false,
}) => {
  const { id } = useParams();
  const [modalupload, setModalUpload] = useState({
    lifeCycleAssessmentsDoc: false,
    significantRisksFromLCADoc: false,
    recycledOrReusedMaterialDoc: false,
    reclaimedProductsAndPackagingDoc: false,
    reclaimedProductsPercentageDoc: false,
  });
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [progress, setUploadProgress] = useState([]);
  const [open, setOpen] = useState(false);
  const [formData1, setFormData1] = useState({});
  const navigate = useNavigate();
  const [disabled, setDisabled] = useState(false);

  const [currentYearData, setCurrentYearData] = useState({
    plasticsReUsed: "",
    plasticsRecycled: "",
    plasticsSafelyDisposed: "",
    eWasteReUsed: "",
    eWasteRecycled: "",
    eWasteSafelyDisposed: "",
    hazardousWasteReUsed: "",
    hazardousWasteRecycled: "",
    hazardousWasteSafelyDisposed: "",
    otherWasteReUsed: "",
    otherWasteRecycled: "",
    otherWasteSafelyDisposed: "",
  });

  const [previousYearData, setPreviousYearData] = useState({
    plasticsReUsed: "",
    plasticsRecycled: "",
    plasticsSafelyDisposed: "",
    eWasteReUsed: "",
    eWasteRecycled: "",
    eWasteSafelyDisposed: "",
    hazardousWasteReUsed: "",
    hazardousWasteRecycled: "",
    hazardousWasteSafelyDisposed: "",
    otherWasteReUsed: "",
    otherWasteRecycled: "",
    otherWasteSafelyDisposed: "",
  });
  const [errors, setErrors] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [radioValue, setRadioValue] = useState("Yes");
  const [tabErrors, setTabErrors] = useState({});
  const [tabErrors1, setTabErrors1] = useState({});
  const [tabErrors2, setTabErrors2] = useState({});
  const [tabErrors3, setTabErrors3] = useState({});
  const [currentErrors, setCurrentErrors] = useState({});
  const [previousErrors, setPreviousErrors] = useState({});

  const inputData = [
    {
      fieldName: "significantRisksFromLCA",
      title:
        "2. If there are any significant social or environmental concerns and/or risks arising from production or disposal of your products / services, as identified in the Life Cycle Perspective / Assessments (LCA) or through any other means, briefly describe the same along-with action taken to mitigate the same.",
      fields: [
        {
          fieldName: "productName",
          title: "Name of Product /Service",
          type: "text",
          placeholder: "Enter Text",
        },
        {
          fieldName: "descriptionOfRisk",
          title: "Description of the risk / concern",
          type: "text",
          placeholder: "Enter Text",
        },
        {
          fieldName: "actionTaken",
          title: "Action Taken",
          type: "text",
          placeholder: "Enter Text",
        },
      ],
    },
  ];

  const inputData1 = [
    {
      fieldName: "recycledOrReusedMaterial",
      title:
        "3. Percentage of recycled or reused input material to total material (by value) used in production (for manufacturing industry) or providing services (for service industry).",
      fields: [
        {
          fieldName: "indicateInputMaterial",
          title: "Indicate input material",
          type: "text",
          placeholder: "Enter Text",
        },
        {
          fieldName: "currentFinancialYear",
          title: "Percentage in Current Financial Year",
          type: "percentage",
          placeholder: "Enter %",
        },
        {
          fieldName: "previousFinancialYear",
          title: "Percentage in Previous Financial Year",
          type: "percentage",
          placeholder: "Enter %",
        },
      ],
    },
  ];

  const inputData2 = [
    {
      fieldName: "reclaimedProductsPercentage",
      title:
        "5. Reclaimed products and their packaging materials (as percentage of products sold) for each product category.",
      fields: [
        {
          fieldName: "productCategory",
          title: "Indicate product category",
          type: "text",
          placeholder: "Enter Text",
        },
        {
          fieldName: "percentage",
          title:
            "Reclaimed products and their packaging materials as % of total products sold in respective category",
          type: "text",
          placeholder: "Enter Text",
        },
      ],
    },
  ];

  const inputData3 = [
    {
      fieldName: "assessments",
      // title: "If yes, provide details:",
      fields: [
        {
          fieldName: "nicCode",
          title: "NIC Code",
          type: "text",
          placeholder: "Enter Text",
          width: "10%",
        },
        {
          fieldName: "productName",
          title: "Name of Product /Service",
          type: "text",
          placeholder: "Enter Text",
          width: "11%",
        },
        {
          fieldName: "percentageOfTurnover",
          title: "% of total Turnover contributed",
          type: "percentage",
          placeholder: "Enter %",
          width: "11%",
        },
        {
          fieldName: "boundary",
          title:
            "Boundary for which the Life Cycle Perspective / Assessment was conducted",
          type: "text",
          placeholder: "Enter Text",
          width: "12%",
        },
        {
          fieldName: "conductedByExternalAgency",
          title: "Whether conducted by independent external agency",
          type: "select",
          options: ["Yes", "No"],
          placeholder: "Select",
          width: "12%",
          inputWidth: "100%",
        },
        {
          fieldName: "resultsPublicDomain",
          title: "Results communicated in the public domain. ",
          type: "select",
          options: ["Yes", "No"],
          placeholder: "Select",
          width: "12%",
          inputWidth: "100%",
        },
        {
          fieldName: "webLink",
          title: "If yes, provide the web link",
          type: "text",
          placeholder: "Enter Text",
          width: "12%",
        },
      ],
    },
  ];

  const handleRadioChange = (event) => {
    setRadioValue(event.target.value);
  };

  const handleTableInputChange = (e, rowIndex, tableType) => {
    const { name, value } = e.target;
    const updatedTable = [...tableType];
    updatedTable[rowIndex] = { ...updatedTable[rowIndex], [name]: value };
    setTables(updatedTable); // or setTables1, setTables2, setTables3 based on table
  };

  const [tables, setTables] = React.useState(
    // inputData.map((section) => ({ fieldName: section.fieldName, rows: [{}] }))
    [],
  );

  const [tables1, setTables1] = React.useState(
    // inputData1.map((section) => ({ fieldName: section.fieldName, rows: [{}] }))
    [],
  );

  const [tables2, setTables2] = React.useState(
    // inputData2.map((section) => ({ fieldName: section.fieldName, rows: [{}] }))
    [],
  );

  const [tables3, setTables3] = React.useState(
    // inputData3.map((section) => ({ fieldName: section.fieldName, rows: [{}] }))
    [],
  );
  const [data, setData] = useState({});

  const type = "SectionC";

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(
          `${api}/brsr/get?subType=principle2&type=${type}&id=${id}`,
        );
        if (
          response?.data?.data?.year
            ? response?.data?.data?.year < currentYear - 1
            : false || !brsrReview
        )
          setDisabled(true);

        if (
          response &&
          response.data &&
          response.data.data.BRSRSectionC &&
          response.data.data.BRSRSectionC.principle2.leadershipIndicator
        ) {
          const leadershipIndicator =
            response.data.data.BRSRSectionC.principle2.leadershipIndicator;

          setFormData1(leadershipIndicator);
          setData(leadershipIndicator);

          if (leadershipIndicator?.reclaimedProductsAndPackaging) {
            const { currentFinancialYear, previousFinancialYear } =
              leadershipIndicator.reclaimedProductsAndPackaging;

            setCurrentYearData({
              plasticsReUsed: currentFinancialYear.plastics?.reUsed ?? "",
              plasticsRecycled: currentFinancialYear.plastics?.recycled ?? "",
              plasticsSafelyDisposed:
                currentFinancialYear.plastics?.safelyDisposed ?? "",
              eWasteReUsed: currentFinancialYear.eWaste?.reUsed ?? "",
              eWasteRecycled: currentFinancialYear.eWaste?.recycled ?? "",
              eWasteSafelyDisposed:
                currentFinancialYear.eWaste?.safelyDisposed ?? "",
              hazardousWasteReUsed:
                currentFinancialYear.hazardousWaste?.reUsed ?? "",
              hazardousWasteRecycled:
                currentFinancialYear.hazardousWaste?.recycled ?? "",
              hazardousWasteSafelyDisposed:
                currentFinancialYear.hazardousWaste?.safelyDisposed ?? "",
              otherWasteReUsed: currentFinancialYear.otherWaste?.reUsed ?? "",
              otherWasteRecycled:
                currentFinancialYear.otherWaste?.recycled ?? "",
              otherWasteSafelyDisposed:
                currentFinancialYear.otherWaste?.safelyDisposed ?? "",
            });

            setPreviousYearData({
              plasticsReUsed: previousFinancialYear.plastics?.reUsed ?? "",
              plasticsRecycled: previousFinancialYear.plastics?.recycled ?? "",
              plasticsSafelyDisposed:
                previousFinancialYear.plastics?.safelyDisposed ?? "",
              eWasteReUsed: previousFinancialYear.eWaste?.reUsed ?? "",
              eWasteRecycled: previousFinancialYear.eWaste?.recycled ?? "",
              eWasteSafelyDisposed:
                previousFinancialYear.eWaste?.safelyDisposed ?? "",
              hazardousWasteReUsed:
                previousFinancialYear.hazardousWaste?.reUsed ?? "",
              hazardousWasteRecycled:
                previousFinancialYear.hazardousWaste?.recycled ?? "",
              hazardousWasteSafelyDisposed:
                previousFinancialYear.hazardousWaste?.safelyDisposed ?? "",
              otherWasteReUsed: previousFinancialYear.otherWaste?.reUsed ?? "",
              otherWasteRecycled:
                previousFinancialYear.otherWaste?.recycled ?? "",
              otherWasteSafelyDisposed:
                previousFinancialYear.otherWaste?.safelyDisposed ?? "",
            });
          }

          if (leadershipIndicator?.lifeCycleAssessments?.status !== undefined) {
            setRadioValue(
              leadershipIndicator.lifeCycleAssessments.status ? "Yes" : "No",
            );
          }
          // if (leadershipIndicator?.lifeCycleAssessments?.assessments) {
          //   setTables3([
          //     {
          //       fieldName: "assessments", // Optional: keep this if needed for consistency
          //       rows: leadershipIndicator.lifeCycleAssessments.assessments.map(
          //         (product) => ({
          //           nicCode: product.nicCode || "",
          //           productName: product.productName || "",
          //           percentageOfTurnover: product.percentageOfTurnover || "",
          //           boundary: product.boundary || "",
          //           conductedByExternalAgency:
          //             product.conductedByExternalAgency || "",
          //           resultsPublicDomain: product.resultsPublicDomain || "",
          //           webLink: product.webLink || "",
          //         })
          //       ),
          //     },
          //   ]);
          // }
        } else {
          console.error("leadership Indicators data is not available.");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [api, id, type]);

  const handleInputChange = (e, year) => {
    const { name, value } = e.target;

    if (year === "current") {
      setCurrentYearData((prev) => ({ ...prev, [name]: value }));
      setCurrentErrors((prevErrors) => ({ ...prevErrors, [name]: "" })); // Reset only current year errors
    } else if (year === "previous") {
      setPreviousYearData((prev) => ({ ...prev, [name]: value }));
      setPreviousErrors((prevErrors) => ({ ...prevErrors, [name]: "" })); // Reset only previous year errors
    }
  };

  const isEmptyValue = (value) =>
    value === null || value === undefined || String(value).trim() === "";

  const validateField = (name, value) => {
    if (isEmptyValue(value)) return "This field is required.";
    if (isNaN(value)) return "Value must be a number.";
    if (value < 0) return "Value must be non-negative.";
    return "";
  };

  const validateRow = (rowData, fieldLabels) => {
    const rowErrors = {};
    const isRowFilled = Object.values(rowData).some((value) => value !== "");

    if (isRowFilled) {
      Object.keys(rowData).forEach((field) => {
        if (isEmptyValue(rowData[field])) {
          rowErrors[field] = `${fieldLabels[field]} is required.`;
        } else if (isNaN(rowData[field])) {
          rowErrors[field] = `${fieldLabels[field]} must be a number.`;
        } else if (rowData[field] < 0) {
          rowErrors[field] = `${fieldLabels[field]} must be non-negative.`;
        }
      });
    }

    return rowErrors;
  };

  const validateForm = () => {
    const currentErrors = {};
    const previousErrors = {};
    console.log("currenterYearData", currentYearData);
    const fieldLabels = {
      plasticsReUsed: "Plastics ReUsed",
      plasticsRecycled: "Plastics Recycled",
      plasticsSafelyDisposed: "Plastics Safely Disposed",
      eWasteReUsed: "E-Waste ReUsed",
      eWasteRecycled: "E-Waste Recycled",
      eWasteSafelyDisposed: "E-Waste Safely Disposed",
      hazardousWasteReUsed: "Hazardous Waste ReUsed",
      hazardousWasteRecycled: "Hazardous Waste Recycled",
      hazardousWasteSafelyDisposed: "Hazardous Waste Safely Disposed",
      otherWasteReUsed: "Other Waste ReUsed",
      otherWasteRecycled: "Other Waste Recycled",
      otherWasteSafelyDisposed: "Other Waste Safely Disposed",
    };

    // // Validate current year data row by row
    Object.keys(currentYearData)
      .reduce((rows, field, index) => {
        const rowIndex = Math.floor(index / 3); // 3 fields per row
        if (!rows[rowIndex]) rows[rowIndex] = {};
        rows[rowIndex][field] = currentYearData[field];
        return rows;
      }, [])
      .forEach((rowData, rowIndex) => {
        const rowErrors = validateRow(rowData, fieldLabels);
        console.log("currentErrors=rowErrors", rowErrors);
        if (Object.keys(rowErrors).length > 0) {
          Object.assign(currentErrors, rowErrors);
        }
      });

    console.log("currentErrors", currentErrors);

    // // Validate previous year data row by row
    Object.keys(previousYearData)
      .reduce((rows, field, index) => {
        const rowIndex = Math.floor(index / 3); // 3 fields per row
        if (!rows[rowIndex]) rows[rowIndex] = {};
        rows[rowIndex][field] = previousYearData[field];
        return rows;
      }, [])
      .forEach((rowData, rowIndex) => {
        const rowErrors = validateRow(rowData, fieldLabels);
        if (Object.keys(rowErrors).length > 0) {
          Object.assign(previousErrors, rowErrors);
        }
      });

    // Update error states
    setCurrentErrors(currentErrors);
    setPreviousErrors(previousErrors);

    // Return validation result
    return (
      Object.keys(currentErrors).length === 0 &&
      Object.keys(previousErrors).length === 0
    );
  };

  const handleSubmit = async () => {
    if (!disabled) {
      if (
        radioValue === "Yes" &&
        !validateTable(inputData3, tables3, setTabErrors3)
      ) {
        return;
      }
      const isFormValid = validateForm();
      // const isTable1Valid = validateTable(inputData, tables, setTabErrors);
      // const isTable2Valid = validateTable(inputData1, tables1, setTabErrors1);
      // const isTable3Valid = validateTable(inputData2, tables2, setTabErrors2);
      const isTable1Valid = validateLeadershipTable(
        inputData,
        tables,
        setTabErrors,
      );
      const isTable2Valid = validateLeadershipTable(
        inputData1,
        tables1,
        setTabErrors1,
      );
      const isTable3Valid = validateLeadershipTable(
        inputData2,
        tables2,
        setTabErrors2,
      );
      const isTable4Valid =
        radioValue === "Yes"
          ? validateTable(inputData3, tables3, setTabErrors3)
          : true;

      if (
        !isFormValid ||
        !isTable1Valid ||
        !isTable2Valid ||
        !isTable3Valid ||
        !isTable4Valid
      ) {
        return;
      }

      // Helper function to map rows for a specific table
      const mapRows = (rows, fields) =>
        rows.filter((row) =>
          Object.values(row).some(
            (value) => value !== undefined && value !== "",
          ),
        );

      // Construct the payload
      const payload = {
        leadershipIndicator: {
          ...formData1,
          significantRisksFromLCA: mapRows(
            tables.find(
              (table) => table.fieldName === "significantRisksFromLCA",
            )?.rows || [],
            ["productName", "descriptionOfRisk", "actionTaken"],
          ).map((row) => ({
            productName: row.productName,
            descriptionOfRisk: row.descriptionOfRisk,
            actionTaken: row.actionTaken,
          })),

          lifeCycleAssessments: {
            status: radioValue === "Yes",
            assessments: mapRows(
              tables3.find((table) => table.fieldName === "assessments")
                ?.rows || [],
              [
                "nicCode",
                "productName",
                "percentageOfTurnover",
                "boundary",
                "conductedByExternalAgency",
                "resultsPublicDomain",
                "webLink",
              ],
            ).map((row) => ({
              nicCode: row.nicCode,
              productName: row.productName,
              percentageOfTurnover: row.percentageOfTurnover,
              boundary: row.boundary,
              conductedByExternalAgency: row.conductedByExternalAgency,
              resultsPublicDomain: row.resultsPublicDomain,
              webLink: row.webLink,
            })),
          },

          recycledOrReusedMaterial: mapRows(
            tables1.find(
              (table) => table.fieldName === "recycledOrReusedMaterial",
            )?.rows || [],
            [
              "indicateInputMaterial",
              "currentFinancialYear",
              "previousFinancialYear",
            ],
          ).map((row) => ({
            indicateInputMaterial: row.indicateInputMaterial,
            currentFinancialYear: row.currentFinancialYear,
            previousFinancialYear: row.previousFinancialYear,
          })),

          reclaimedProductsPercentage: mapRows(
            tables2.find(
              (table) => table.fieldName === "reclaimedProductsPercentage",
            )?.rows || [],
            ["productCategory", "percentage"],
          ).map((row) => ({
            productCategory: row.productCategory,
            percentage: row.percentage,
          })),
          reclaimedProductsAndPackaging: {
            currentFinancialYear: {
              plastics: {
                reUsed: currentYearData.plasticsReUsed,
                recycled: currentYearData.plasticsRecycled,
                safelyDisposed: currentYearData.plasticsSafelyDisposed,
              },
              eWaste: {
                reUsed: currentYearData.eWasteReUsed,
                recycled: currentYearData.eWasteRecycled,
                safelyDisposed: currentYearData.eWasteSafelyDisposed,
              },
              hazardousWaste: {
                reUsed: currentYearData.hazardousWasteReUsed,
                recycled: currentYearData.hazardousWasteRecycled,
                safelyDisposed: currentYearData.hazardousWasteSafelyDisposed,
              },
              otherWaste: {
                reUsed: currentYearData.otherWasteReUsed,
                recycled: currentYearData.otherWasteRecycled,
                safelyDisposed: currentYearData.otherWasteSafelyDisposed,
              },
            },
            previousFinancialYear: {
              plastics: {
                reUsed: previousYearData.plasticsReUsed,
                recycled: previousYearData.plasticsRecycled,
                safelyDisposed: previousYearData.plasticsSafelyDisposed,
              },
              eWaste: {
                reUsed: previousYearData.eWasteReUsed,
                recycled: previousYearData.eWasteRecycled,
                safelyDisposed: previousYearData.eWasteSafelyDisposed,
              },
              hazardousWaste: {
                reUsed: previousYearData.hazardousWasteReUsed,
                recycled: previousYearData.hazardousWasteRecycled,
                safelyDisposed: previousYearData.hazardousWasteSafelyDisposed,
              },
              otherWaste: {
                reUsed: previousYearData.otherWasteReUsed,
                recycled: previousYearData.otherWasteRecycled,
                safelyDisposed: previousYearData.otherWasteSafelyDisposed,
              },
            },
          },
        },
        leadershipIndicatorSubmitted: true,

        type: "SectionC",
        subType: "principle2",
      };
      console.log("payload", payload);
      try {
        const response = await put(`brsr/update?id=${id}`, payload);
        setsnackOpen({
          open: true,
          message: "Data saved successfully!",
          severity: "success",
        });
        navigate(`/brsr/section-c/principle3/${id}`);
        if (onSave) onSave(response.data);
      } catch (error) {
        console.error(error);
        setsnackOpen({
          open: true,
          message: "Failed to save data. Please try again.",
          severity: "error",
        });
      }
    } else navigate(`/brsr/section-c/principle3/${id}`);
  };
  console.log("payloadfor", formData1);
  return (
    <Box>
      <p className={style.subHeading}>II. LEADERSHIP INDICATIOR</p>
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "16px",
          textIndent: "-1rem",
          paddingLeft: "0.8rem",
          fontFamily: "Inter",
          mt: 2,
        }}
        gutterBottom
      >
        1. Has the entity conducted Life Cycle Perspective / Assessments (LCA)
        for any of its products (for manufacturing industry) or for its services
        (for service industry) (Yes ? No)? If yes, provide details:
      </Typography>
      <RadioGroup
        row
        value={radioValue}
        disabled={disabled}
        onChange={handleRadioChange}
        sx={{ mb: 2, marginLeft: "0.8rem" }}
      >
        <FormControlLabel
          value="Yes"
          control={<Radio disabled={disabled} />}
          label="Yes"
        />
        <FormControlLabel
          value="No"
          control={<Radio disabled={disabled} />}
          label="No"
        />
      </RadioGroup>
      {radioValue === "Yes" && (
        <>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              textIndent: "-1rem",
              paddingLeft: "0.8rem",
              fontFamily: "Inter",
              ml: 2,
              marginBottom: "-0.5rem",
            }}
            gutterBottom
          >
            If yes, provide details:
          </Typography>
          <DynamicTable
            inputData={inputData3}
            tables={tables3}
            data={data.lifeCycleAssessments}
            setTables={setTables3}
            errors={tabErrors3}
            setErrors={setTabErrors3}
            disabled={disabled}
            hide={hide}
          />
          <BRSRFile
            {...{
              modalupload,
              setModalUpload,
              formData: formData1,
              setFormData: setFormData1,
              errors,
              setErrors,
              open,
              setOpen,
              Uploadkey: "lifeCycleAssessmentsDoc",
              ml: 2,
              removeUpload,
            }}
          />
        </>
      )}
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <DynamicTable
        inputData={inputData}
        tables={tables}
        data={data}
        setTables={setTables}
        errors={tabErrors}
        setErrors={setTabErrors}
        disabled={disabled}
        hide={hide}
      />
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData: formData1,
          setFormData: setFormData1,
          errors,
          setErrors,
          open,
          setOpen,
          Uploadkey: "significantRisksFromLCADoc",
          ml: 2,
          removeUpload,
        }}
      />
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <DynamicTable
        inputData={inputData1}
        tables={tables1}
        setTables={setTables1}
        data={data}
        errors={tabErrors1}
        setErrors={setTabErrors1}
        disabled={disabled}
        hide={hide}
      />
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData: formData1,
          setFormData: setFormData1,
          errors,
          setErrors,
          open,
          setOpen,
          Uploadkey: "recycledOrReusedMaterialDoc",
          ml: 2,
          removeUpload,
        }}
      />

      <Box>
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: "16px",
            mt: 2,
            textIndent: "-1rem",
            paddingLeft: "0.8rem",
            fontFamily: "Inter",
          }}
          gutterBottom
        >
          4. Of the products and packaging reclaimed at end of life of products,
          amount (in metric tonnes) reused, recycled, and safely disposed:
        </Typography>
        <Box sx={{ marginLeft: "1rem", width: "98%" }}>
          <FinancialYearTable
            title="a. Current Financial Year"
            formData={currentYearData}
            handleInputChange={(e) => handleInputChange(e, "current")}
            errors={currentErrors}
            disabled={disabled}
          />

          {Object.entries(currentErrors)
            .filter(([field]) =>
              [
                "otherWasteReUsed",
                "otherWasteRecycled",
                "otherWasteSafelyDisposed",
                "hazardousWasteReUsed",
                "hazardousWasteRecycled",
                "hazardousWasteSafelyDisposed",
                "eWasteReUsed",
                "eWasteRecycled",
                "eWasteSafelyDisposed",
                "plasticsReUsed",
                "plasticsRecycled",
                "plasticsSafelyDisposed",
              ].includes(field),
            )
            .reduce((acc, [_, errorMessage], index, arr) => {
              return acc + errorMessage + (index < arr.length - 1 ? " & " : "");
            }, "") && (
            <Typography
              color="error"
              style={{
                lineHeight: "1.2",
                margin: "2px 0",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
              }}
            >
              {Object.entries(currentErrors)
                .filter(([field]) =>
                  [
                    "otherWasteReUsed",
                    "otherWasteRecycled",
                    "otherWasteSafelyDisposed",
                    "hazardousWasteReUsed",
                    "hazardousWasteRecycled",
                    "hazardousWasteSafelyDisposed",
                    "eWasteReUsed",
                    "eWasteRecycled",
                    "eWasteSafelyDisposed",
                    "plasticsReUsed",
                    "plasticsRecycled",
                    "plasticsSafelyDisposed",
                  ].includes(field),
                )
                .reduce((acc, [_, errorMessage], index, arr) => {
                  return (
                    acc + errorMessage + (index < arr.length - 1 ? "  " : "")
                  );
                }, "")}
            </Typography>
          )}
        </Box>

        {/* Previous Financial Year Table */}
        <Box sx={{ marginLeft: "1rem", width: "98%" }}>
          <FinancialYearTable
            title="b. Previous Financial Year"
            formData={previousYearData}
            handleInputChange={(e) => handleInputChange(e, "previous")}
            errors={previousErrors}
            disabled={disabled}
          />

          {Object.entries(previousErrors)
            .filter(([field]) =>
              [
                "otherWasteReUsed",
                "otherWasteRecycled",
                "otherWasteSafelyDisposed",
                "hazardousWasteReUsed",
                "hazardousWasteRecycled",
                "hazardousWasteSafelyDisposed",
                "eWasteReUsed",
                "eWasteRecycled",
                "eWasteSafelyDisposed",
                "plasticsReUsed",
                "plasticsRecycled",
                "plasticsSafelyDisposed",
              ].includes(field),
            )
            .reduce((acc, [_, errorMessage], index, arr) => {
              return acc + errorMessage + (index < arr.length - 1 ? " & " : "");
            }, "") && (
            <Typography
              color="error"
              style={{
                lineHeight: "1.2",
                margin: "2px 0",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
              }}
            >
              {Object.entries(previousErrors)
                .filter(([field]) =>
                  [
                    "otherWasteReUsed",
                    "otherWasteRecycled",
                    "otherWasteSafelyDisposed",
                    "hazardousWasteReUsed",
                    "hazardousWasteRecycled",
                    "hazardousWasteSafelyDisposed",
                    "eWasteReUsed",
                    "eWasteRecycled",
                    "eWasteSafelyDisposed",
                    "plasticsReUsed",
                    "plasticsRecycled",
                    "plasticsSafelyDisposed",
                  ].includes(field),
                )
                .reduce((acc, [_, errorMessage], index, arr) => {
                  return (
                    acc + errorMessage + (index < arr.length - 1 ? "  " : "")
                  );
                }, "")}
            </Typography>
          )}
        </Box>
      </Box>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData: formData1,
          setFormData: setFormData1,
          errors,
          setErrors,
          open,
          setOpen,
          Uploadkey: "reclaimedProductsAndPackagingDoc",
          ml: 2,
          removeUpload,
        }}
      />
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <DynamicTable
        inputData={inputData2}
        tables={tables2}
        data={data}
        setTables={setTables2}
        errors={tabErrors2}
        setErrors={setTabErrors2}
        disabled={disabled}
        hide={hide}
      />
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData: formData1,
          setFormData: setFormData1,
          errors,
          setErrors,
          open,
          setOpen,
          Uploadkey: "reclaimedProductsPercentageDoc",
          ml: 2,
          removeUpload,
        }}
      />
      {!hide && (
        <>
          {brsrReview ? (
            <Box sx={{ ml: "1rem", width: "98%" }}>
              <ReviewBox
                url={`/brsr/review/${id}`}
                handleSubmit={handleSubmit}
              />
            </Box>
          ) : (
            <Box textAlign="right" sx={{ mt: 3 }}>
              <Button
                variant="contained"
                sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
                onClick={handleSubmit}
              >
                Save & Continue <EastIcon sx={{ ml: 2 }} />
              </Button>
            </Box>
          )}
        </>
      )}
      <Snackbar
        open={snackOpen.open}
        message={snackOpen.message}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setsnackOpen({ ...snackOpen, open: false })}
      >
        <Alert
          severity={snackOpen.severity || "info"} // Ensure a default severity if undefined
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackOpen.message || "No message provided"}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default LeadershipIndicator;
